var createError = require('../utils/custom_error').create;

exports.Error = createError('TagError');
